import { HTMLAttributes, memo } from 'react';
import TradeDetailClassicView from './TradeDetailClassicView';
import { useTradeDetailBusiness } from './useTradeDetailBusiness';
export { LogisticsContent } from './styles';

export interface TradeDetailProps extends HTMLAttributes<HTMLElement> {
  sendable?: boolean;
  trade: Conversation.Trade.TradeWithLogistics;
}

function TradeDetail(props: TradeDetailProps) {
  const { sendable = true, trade, ...otherProps } = props;

  const { blocks, conversation, storeType } = useTradeDetailBusiness({
    trade,
    sendable,
  });

  if (blocks.length === 0) {
    return null;
  }

  return (
    <TradeDetailClassicView
      {...otherProps}
      trade={trade}
      blocks={blocks}
      conversation={conversation}
      storeType={storeType}
    />
  );
}

export default memo(TradeDetail);
